import { render, staticRenderFns } from "./Places.vue?vue&type=template&id=2455d68b&scoped=true&"
import script from "./Places.vue?vue&type=script&lang=js&"
export * from "./Places.vue?vue&type=script&lang=js&"
import style0 from "./Places.vue?vue&type=style&index=0&id=2455d68b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2455d68b",
  null
  
)

export default component.exports